var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.shippingTypes),function(shippingType,key){return _c('input',{key:key,attrs:{"name":"shippingType","type":"hidden"},domProps:{"value":key}})}),0)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42f3bee4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/templates/semperit/assets/js/modules/checkout/components/shipping-type/components/ShippingType.vue
// module id = 5STu
// module chunks = 4